<template>
  <div style="padding-top:0.625rem;">
    <el-row>
      <el-col :span="4">
		  <el-image :src="logoSrc"></el-image>
	  </el-col>
      <el-col :span="16">
		  <ul class="menu_ul2">
			  <li @click="toIndex"><span>首页</span></li>
			  <li><span>/</span></li>
			  <li @click="toRequirement"><span>需求大厅</span></li>
			  <li><span>/</span></li>
			  <li @click="toQiye"><span>企业发包</span></li>
			  <li><span>/</span></li>
			  <li @click="toFuwu"><span>服务产品</span></li>
			  <li><span>/</span></li>
			  <li @click="toGuanyu"><span>关于我们</span></li>
		  </ul>
	  </el-col>
      <el-col :span="4">
		  <template v-if="!loginFlag">
			  <ul class="menu_ul right_menu_ul">
				  <li @click="toLogin"><span>登录</span></li>
				  <li><span>/</span></li>
				  <li @click="toRegister"><span>注册</span></li>
			  </ul>
		  </template>
		  <template v-else>
			  <ul class="menu_ul right_menu_ul" style="list-style-type: none;">
				  <!-- <li>
					  <template class="submenu-title" slot="title">
					    <el-avatar
					      :src="userInfo.avatar && userInfo.avatar != '' ?
					      userInfo.avatar : require('../../assets/admin/avatar.png')"/>
					    <span class="left-margin">{{userInfo.userName}}</span>
					  </template>
				  </li> -->
				  <li @click="toUserCenter" v-if="userInfo.userType=='00'">
						<span><i class="el-icon-user-solid"/>企业中心</span>
				  </li>
				  <li @click="toUserCenter" v-if="userInfo.userType=='01'">
						<span><i class="el-icon-user-solid"/>个人中心</span>
				  </li>
				  <li @click="logout">
				  		<span><i<i class="el-icon-switch-button"/>退出登录</span>
				  </li>
			  </ul>
		  </template>
	  </el-col>
    </el-row>
  </div>
</template>

<script>
  import {mapState} from "vuex"
  import connect from '@/util/connect.js'

  export default {
    name: 'baseHeader',
    data() {
      return {
        activeIndex: "/",
        logoSrc: require("../../assets/index_new/logo2.png")
      }
    },
    mounted() {
		console.table(this.$route);
      this.activeIndex = this.$route.path;
    },
    computed: {
      ...mapState({
        userInfo: state => state.user.userInfo,
        loginFlag: state => state.user.loginFlag
      }),
    },
    methods: {
	  // 路由到首页
	  toIndex() {
	    this.$router.push("/")
	  },
	  // 路由到需求大厅
	  toRequirement() {
	    this.$router.push("/requirement")
	  },
	  // 路由到企业发包
	  toQiye() {
	    this.$router.push("/distribute")
	  },
	  // 路由到服务产品
	  toFuwu() {
	    this.$router.push("/ecology")
	  },
	  // 路由到关于我们
	  toGuanyu() {
	    this.$router.push("/join")
	  },
		
      // 路由到登录页
      toLogin() {
        this.$router.push("/login")
      },
      // 路由到注册页
      toRegister() {
        this.$router.push("/register")
      },
      // 跳转到企业中心
      toUserCenter() {
        window.open("https://admin.kefubang.com", '_blank')
      },
      logout() {
        this.$store.dispatch("LogOut").then(() => {
          this.$message("退出登录！")
        })
      },
	  contact() {
	  	document.getElementById("nb_invite_ok").click();
	  }
    }
  }

</script>
<style>
	ul.menu_ul2{padding-left: 11.9375rem;}
	ul.menu_ul2 li{float:left;list-style-type: none;padding:0 0.625rem;color:black;font-size:0.875rem;cursor: pointer;}
	ul.right_menu_ul{padding-left:0;}
	ul.right_menu_ul li{padding-left:0;}
	
</style>
<style scoped>
  @import "../../assets/css/common.css";

</style>